import { ref } from 'vue';
import Request from '@/services/request';
import { EARLY_SETTLEMENT_HISTORY } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useEarlySettlementHistory() {
  const data = ref([]);
  const error = ref(null);
  const isLoading = ref(false);

  const fetchData = async () => {
    isLoading.value = true;
    try {
      const response = await Req.get(EARLY_SETTLEMENT_HISTORY, null, {
        baseURL: '/sellerofficeapi/rest',
        headers: { Accept: 'application/json' },
      });

      if (response.status === 200) {
        data.value = response.data || [];
        error.value = null;
      } else {
        throw new Error('Network response was not OK');
      }
    } catch (err) {
      error.value = err || null;
      data.value = [];
    } finally {
      isLoading.value = false;
    }
  };

  return {
    data,
    error,
    isLoading,
    fetchData,
  };
}


